import { render, staticRenderFns } from "./UpdateAddressDialog.vue?vue&type=template&id=cca43b1e&"
import script from "./UpdateAddressDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports